import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PasswordField from "../components/PasswordField";

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setError("");
    setLoading(true);

    try {
      const { error: signInError } = await signIn(email.trim(), password);
      if (signInError) setError(signInError.message);
      else navigate("/");
    } catch (err) {
      console.error("Sign in failed:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-card">
        <h2 className="auth-title">Welcome back</h2>
        <p className="auth-sub">Sign in to your Aquaviva Foods account.</p>

        <form onSubmit={handleSubmit}>
          {error && (
            <p className="ui-alert ui-alert--error" role="alert">
              {error}
            </p>
          )}

          <div className="ui-field">
            <label className="ui-label" htmlFor="login-email">Email address</label>
            <input
              id="login-email"
              className="ui-input"
              type="email"
              placeholder="you@example.com"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <PasswordField
            id="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
            autoComplete="current-password"
            labelAside={<Link to="/reset-password">Forgot your password?</Link>}
          />

          <button
            type="submit"
            className="ui-btn ui-btn--primary ui-btn--block"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        <p className="auth-foot">
          New to Aquaviva Foods? <Link to="/signup">Create an account</Link>
        </p>
      </div>
    </div>
  );
}